export default __webpack_public_path__ + "static/media/arrow_up.3fb79ab2.svg";